module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Thumbnail",
    style: (_vm.styles),
    on: {
      "mouseenter": function($event) {
        _vm.hover = true
      },
      "mouseleave": function($event) {
        _vm.hover = false
      }
    }
  }, [_c('div', {
    staticClass: "Thumbnail-imageContainer",
    style: (_vm.imageContainerStyles)
  }, [(_vm.ratio) ? _c('crop', [_c('image-component', _vm._b({}, 'image-component', _vm.image, false))], 1) : _vm._e(), _vm._v(" "), (!_vm.ratio) ? _c('image-component', _vm._b({}, 'image-component', _vm.image, false)) : _vm._e()], 1), _vm._v(" "), (_vm.tags || _vm.button) ? _c('div', {
    staticClass: "Thumbnail-tags"
  }, [(_vm.button) ? _c('tag', _vm._b({
    staticClass: "Thumbnail-button",
    attrs: {
      "highlighted": _vm.hover,
      "large": ""
    }
  }, 'tag', _vm.button, false)) : _vm._e(), _vm._v(" "), _vm._l((_vm.tags), function(tag, index) {
    return (tag) ? _c('tag', _vm._b({
      key: index,
      staticClass: "Thumbnail-tag",
      attrs: {
        "highlighted": _vm.hover
      }
    }, 'tag', tag, false)) : _vm._e()
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f22843d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thumbnail.vue
// module id = 772
// module chunks = 1474